import React, { PropsWithChildren } from 'react';
import { gql } from '@yi/core';
import { i18n_related_articles } from '@yi/i18n/phrases/i18n_related_articles';

import { Omit } from '~/types';

import { BaseCarouselComposerProps } from './BaseCarousel';
import { RecommendedArticlesCarousel } from './RecommendedArticlesCarousel';
import { useLocale } from '../LocaleProvider';

type CarouselItem = gql.typesClient.Fragment_ArticleCard;

interface Props extends Omit<BaseCarouselComposerProps<CarouselItem>, 'items'> {
  relatedToContentId: string;
}
// @TODO Need to implement algolia related recommendations once we have enough events.
export const RelatedArticlesCarousel: React.FC<PropsWithChildren<Props>> = props => {
  const { locale } = useLocale();
  return <RecommendedArticlesCarousel {...props} heading={i18n_related_articles(locale)} />;
};
